"use client"

import { Button, Heading } from "@modules/common/components/ui"
import { useFrontendPreferences } from "@lib/frontend-preferences"

import CartTotals from "@modules/common/components/cart-totals"
import Divider from "@modules/common/components/divider"
import DiscountCode from "@modules/checkout/components/discount-code"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { HttpTypes } from "@medusajs/types"

type SummaryProps = {
  cart: HttpTypes.StoreCart
}

function getCheckoutStep(cart: HttpTypes.StoreCart) {
  if (!cart?.shipping_address?.address_1 || !cart.email) {
    return "address"
  } else if (cart?.shipping_methods?.length === 0) {
    return "delivery"
  } else {
    return "payment"
  }
}

const Summary = ({ cart }: SummaryProps) => {
  const step = getCheckoutStep(cart)
  const { t } = useFrontendPreferences()

  return (
    <div className="flex flex-col gap-y-5">
      <Heading level="h2" className="sahil-acc-title !text-3xl">
        {t.cart.summary}
      </Heading>
      <DiscountCode cart={cart} />
      <Divider />
      <CartTotals totals={cart} />
      <LocalizedClientLink
        href={"/checkout?step=" + step}
        data-testid="checkout-button"
      >
        <Button className="w-full h-12 !rounded-full">{t.cart.checkout}</Button>
      </LocalizedClientLink>
    </div>
  )
}

export default Summary
